(function() { window.GUID_3954bae9_fef6_4192_ab37_a2a1ef235ed5 = { getGuid: function() { return "3954bae9-fef6-4192-ab37-a2a1ef235ed5"; } }; })();
var CS;
(function (CS) {
    var Enumeration;
    (function (Enumeration) {
        let PremiumFeature;
        (function (PremiumFeature) {
            PremiumFeature[PremiumFeature["Generic"] = 0] = "Generic";
            PremiumFeature[PremiumFeature["StatsCompare"] = 1] = "StatsCompare";
            PremiumFeature[PremiumFeature["StatsGraph"] = 2] = "StatsGraph";
        })(PremiumFeature = Enumeration.PremiumFeature || (Enumeration.PremiumFeature = {}));
    })(Enumeration = CS.Enumeration || (CS.Enumeration = {}));
})(CS || (CS = {}));

//# sourceMappingURL=PremiumFeature.pre.js.map
